import { render, staticRenderFns } from "./ModularRequestTenderPage.vue?vue&type=template&id=2e5ebdac"
import script from "./ModularRequestTenderPage.vue?vue&type=script&lang=js"
export * from "./ModularRequestTenderPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports